import { render, staticRenderFns } from "./zystHome.vue?vue&type=template&id=12a17032&scoped=true"
import script from "./zystHome.vue?vue&type=script&lang=js"
export * from "./zystHome.vue?vue&type=script&lang=js"
import style0 from "./zystHome.vue?vue&type=style&index=0&id=12a17032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a17032",
  null
  
)

export default component.exports